import sendRequest from "../fetch"
import api from '../url'
import { cleanParams } from "@/utils";
import Qs from "qs";

const _base = "ws/chat/";



// 获取用户的聊天室列表
export const getUserRooms = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "room/list", {
    data: _params,
    method: "GET",
    chatToken,
  });
};

// 获取聊天室详情
export const getRoomDetail = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "room/info", {
    data: _params,
    method: "GET",
    chatToken,
  });
};

// 获取聊天室成员列表
export const getRoomMemberList = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "room/memberList", {
    data: _params,
    method: "GET",
    chatToken,
  });
};





// 获取聊天室所有未读消息记录
export const getUnReadMessages = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "room/messages/unRead", {
    data: _params,
    method: "GET",
    chatToken,
  });
};

// 获取或创建一对一聊天室
export const getOrCreatePrivateRoom = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "room/private", {
    data: Qs.stringify(_params),
    method: "POST",
    chatToken,
  });
};



// 标记消息为已读
export const readMessage = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "message/read", {
    data: _params,
    method: "POST",
    chatToken,
  });
};


// 获取某个聊天室下图片或文件列表-分页
export const getFileList = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "file/list", {
    data: _params,
    method: "GET",
    chatToken,
  });
};

// 获取所有辅导老师在线聊天用户列表
export const getTeacherList = (params, chatToken) => {
  let _params = cleanParams(params);
  return sendRequest(api.chatUrl + _base + "teacher/list", {
    data: _params,
    method: "GET",
    chatToken,
  });
};





// WEBPACK FOOTER //
// ./src/fetch/api/chat.js